export default {
      id: "marker-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#marker",
      toString: function () {
        return this.url;
      }
    }